<template>
  <SDataTable :headers="headers" :items="users">
    <template v-slot:item.createdAt="{ item }">
      {{ item.createdAt | dateFilter }}
    </template>

    <template v-slot:item.country="{ item }">
      <div class="d-flex justify-center">
        <img
          :src="`https://countryflagsapi.com/svg/${item.country.toLowerCase()}`"
          width="25"
          crossorigin="anonymous"
        />
      </div>
    </template>

    <template v-slot:item.userType="{ item }">
      <div v-if="item.userType == 'ADMIN'">
        <v-chip
          small
          class="text-sm-overline"
          color="success"
          text-color="white"
        >
          <v-avatar left>
            <v-icon small>fa-crown</v-icon>
          </v-avatar>
          Administrateur
        </v-chip>
      </div>
      <v-chip
        v-else
        small
        class="text-sm-overline"
        color="warning"
        text-color="white"
      >
        <v-chip
          small
          class="text-sm-overline"
          color="warning"
          text-color="white"
        >
          <v-avatar left>
            <v-icon small>fa-user</v-icon>
          </v-avatar>
          Utilisateur
        </v-chip>
      </v-chip>
    </template>

    <template v-slot:item.actions="{ item }">
      <div class="d-flex justify-center">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <SButton
                small
                color="primaryColor"
                icon="fa-eye"
                @click="viewOne(item)"
              ></SButton>
            </div>
          </template>
          <span>Voir</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <SButton
                small
                color="warning"
                icon="fa-edit"
                @click="editOne(item)"
              ></SButton>
            </div>
          </template>
          <span>Modifier</span>
        </v-tooltip>
      </div>
    </template>
  </SDataTable>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import dateFilter from "@filters/dateFilter";

export default {
  name: "UsersTable",
  data: () => ({
    headers: [
      { text: "Nom complet", value: "name", align: "center" },
      { text: "Adresse mail", value: "email", align: "center" },
      { text: "Téléphone", value: "phone", align: "center" },
      { text: "Pays", value: "country", align: "center" },
      { text: "Rôle", value: "userType", align: "center" },
      { text: "Date d'inscription", value: "createdAt", align: "center" },
      { text: "Actions", value: "actions", align: "center" },
    ],
    users: [],
  }),
  methods: {
    viewOne(user) {
      return this.$router.push({ name: "User", params: { userId: user.uid } });
    },
    editOne(user) {
      return this.$emit("askUpdate", user);
    },
    ...mapActions({
      retrieveUsers: "users/retrieveUsers",
    }),
  },
  computed: {
    ...mapGetters({
      getUsers: "users/getUsers",
    }),
  },
  filters: {
    dateFilter,
  },
  async created() {
    try {
      await this.retrieveUsers();
      this.users = this.getUsers;
    } catch ({ success, error }) {
      this.$emit("onErrors", { success, message: error });
    }
  },
};
</script>

<style></style>
